import lightboxContext from "@contexts/lightboxContext";
import { useContext } from "react";

export default () => {
	const context = useContext(lightboxContext);

	return context;
};
